import React from 'react'
import {
  DoubleUpdater,
  IOWidget,
  Updater,
  any,
  async,
  fromJSX,
  inl,
  inr,
  nothing,
} from 'widgets-for-react'
import { CollectionsLoaderState } from '../../collections/collectionsLoader/collectionsLoaderState'
import { isSaved } from '../../collections/collectionsLoader/collectionsLoaderUtils'
import {
  ComponentSaverState,
  componentSaverStateUpdaters,
} from '../../components/componentSaver/componentSaverState'
import { GuestChefHighlightLayout } from './guestChefHighLight.layout'
import { GuestChefHighlightState } from './guestChefHighLight.state'

export const guestChefHighlightWidget =
  (
    collectionsLoaderState: CollectionsLoaderState
  ): IOWidget<
    GuestChefHighlightState,
    DoubleUpdater<ComponentSaverState, GuestChefHighlightState>
  > =>
  (state) =>
    any([
      async(state).map((updater) =>
        inr<Updater<ComponentSaverState>, Updater<GuestChefHighlightState>>(
          updater
        )
      ),
      state.kind == 'unloaded'
        ? nothing()
        : fromJSX((setState) => (
            <GuestChefHighlightLayout
              guestChef={
                state.kind == 'loaded'
                  ? state.value
                  : state.kind == 'loading'
                  ? 'loading'
                  : 'error'
              }
              isSaved={(id) => isSaved(collectionsLoaderState, id)}
              onSaveOrDelete={(componentId) =>
                setState(
                  inl<
                    Updater<ComponentSaverState>,
                    Updater<GuestChefHighlightState>
                  >(componentSaverStateUpdaters.startSavingUpdater(componentId))
                )
              }
            />
          )),
    ])
